<div class="virtual-tour-container">
	<div *ngIf="!isAvailable" class="virtual-tour-unavailable text-center">
		Virtual Tour Unavailable
	</div>
	<iframe width="100%" height="100%" frameBorder="0" [src]="urlSafe" *ngIf="isAvailable"></iframe>
</div>
